import React from 'react';
import useSelect from '../../../services/hooks/UI/useSelect';
import { ReactComponent as ArrowDown } from '../../../assets/icons/ArrowDown.svg';
import NumberInput from '../NumberInput/NumberInput';
import DisplayOptions from '../Selects/DisplayOptions/DisplayOptions';

import classes from './Identification.module.scss';
import { formTypes } from '../../../store/catalogs/forms';
import Tooltip from '../../Tooltip/Tooltip';

const Identification = ({
  disabledType,
  disabled,
  name,
  onBlur,
  errorIndicative,
  keyType,
  valueType,
  onChange,
  onChangeKey,
  validate,
  error,
  value,
  optionsType,
  topPosition
}) => {
  const {
    open,
    divRef,
    containerBlurHandler,
    containerClickHandler,
    containerClasses,
    selectValue,
    filteredOptionsOrCreated,
    inputBlurHandler,
    closedOptions,
    inputRef,
    arrowClickHandler,
    setOptions,
    labelSelected,
    selectOptions
  } = useSelect({
    value: valueType,
    options: optionsType,
    onChange: onChangeKey,
    typeSelect: formTypes.identification,
    className: classes.content,
    error: errorIndicative || error
  });
  const indicativeClass = [classes.container, classes.indicative];
  disabledType && disabled && containerClasses.push(classes['disabled-type']);
  return (
    <div className={containerClasses.join(' ')}>
      {disabledType && selectValue.value === '31' ? (
        <Tooltip position={topPosition} content='No se puede cambiar NIT ya que es una persona jurídica.'>
          <div
            className={`${classes.disabled} ${indicativeClass.join(' ')} `}
            name={keyType}
            tabIndex={0}  
            ref={divRef}
            onBlur={containerBlurHandler}
            onClick={() => {}}>
            <span name={keyType} className='text-ellipsis medium-16'>
              {`${selectValue.shortLabel || selectValue.label || ''}`}
            </span>

            <ArrowDown className='select-icon' onClick={arrowClickHandler} />
          </div>
        </Tooltip>
      ) : (
        <div
          className={`${disabled ? '' : 'pointer'} ${indicativeClass.join(' ')} `}
          name={keyType}
          tabIndex={0}
          ref={divRef}
          onBlur={disabled ? () => {} : containerBlurHandler}
          onClick={disabled ? () => {} : containerClickHandler}>
          <span name={keyType} className='text-ellipsis medium-16'>
            {`${selectValue.shortLabel || selectValue.label || ''}`}
          </span>

          <ArrowDown className={`select-icon ${disabled ? '' : 'pointer'}`} onClick={disabled ? () => {} : arrowClickHandler} />
        </div>
      )}

      <DisplayOptions
        key='Select'
        toogleOpenHandler={closedOptions}
        classContent='select-options'
        open={open}
        options={filteredOptionsOrCreated}
        selected={selectValue.value}
        onChange={setOptions}
        value={labelSelected}
        onBlur={inputBlurHandler}
        reference={inputRef}
        selectOptions={selectOptions}
      />

      <NumberInput
        name={name}
        disabled={disabled}
        className={classes.number}
        classNameFormat={classes.format}
        placeholder={'104493562'}
        error={error}
        validated={validate}
        onChange={numberData => {
          onChange(numberData ? numberData : '');
        }}
        value={value}
        onBlur={onBlur}
        thousandSeparator={false}
        prefix=''
      />
    </div>
  );
};

export default Identification;
